module.exports = __webpack_public_path__ + "static/img/Inspection4.54d3621e.png";